import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FooterWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 62px;
    padding: 16px 20px;
    background: transparent;
    box-sizing: border-box;
    color: inherit;
`;

export const FooterIcon = styled(FontAwesomeIcon)`
    margin: 0 4px;
`;

export const FooterLink = styled.a`
    margin: -2px 4px 0;
    color: inherit;
    text-decoration: none;
    &:hover {
        color: #00bcd2;
    }
`;
